import billRequestFa from './fa/fa.json'

const billRequestMessages = {
  fa: { ...billRequestFa },
}

export default billRequestMessages
